///const ApiUrl = "https://apimenu.qrmenuscan.com";
//const ApiUrl = "https://qrmenuapi.asortek.com.tr";
///const ApiUrl = "https://apimenu.qrmenuscan.com";
const ApiUrl = "https://qrmenuapi.asortek.com.tr";
//const ApiUrl = "https://localhost:5001";

const domainUrl = "https://qrmenu.asortek.com.tr";
//const domainUrl = "http://localhost:3000";
const OrderHubUrl = (companyId: string): HubModel => {
  return {
    url: `${ApiUrl}/orderHub?companyId=${companyId}`,
    event: "ReceiveOrder",
  };
};
const WaiterHubUrl = (companyId: string): HubModel => {
  return {
    url: `${ApiUrl}/waiterHub?companyId=${companyId}`,
    event: "WaiterCall",
  };
};
export { ApiUrl, OrderHubUrl, WaiterHubUrl, domainUrl };

export interface HubModel {
  url: string;
  event: string;
}
